import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';

const { Themes } = Tooltip;
/**
 * IconCell for MatrixTable
 */
const IconCell = ({
  column,
  container,
  className,
  svgClassName,
  svgId,
  svg,
  width,
  height,
  tooltip,
  ...rest
}) => {
  const { content, ...tooltipProps } = typeof tooltip === 'object' ? tooltip : { content: tooltip };
  const _content = content || ('cellData' in rest ? rest.cellData : column.title);
  const _svgId = svgId || column.svgId;
  return (
    <Tooltip
      className={className}
      content={_content}
      theme={Themes.DARK}
      container={container}
      delayShow={150}
      delayHide={150}
      {...tooltipProps}
    >
      <SvgIcon className={svgClassName} svgId={_svgId} width={width} height={height}>
        {svgId ? undefined : svg}
      </SvgIcon>
    </Tooltip>
  );
};

IconCell.defaultProps = {
  width: '18px',
  height: '18px'
};

IconCell.propTypes = {
  column: PropTypes.object,
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Tooltip appended to it.
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  /**
   * Class name for the component
   */
  className: PropTypes.string,
  /**
   * Class name for the svg icon
   */
  svgClassName: PropTypes.string,
  /**
   * SvgId for the option
   */
  svgId: PropTypes.string,
  /**
   * An svg node (can be provided instead of an svgId)
   */
  svg: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  /**
   * Width of the svg icon
   */
  width: PropTypes.string,
  /**
   * Height of the svg icon
   */
  height: PropTypes.string,
  /**
   * Tooltip content, could be an object, see the `propTypes` of `Tooltip` for the available props
   */
  tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.object])
};

export default IconCell;
